import React from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import styled from 'styled-components';

const PaginationWrap = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  .page-item {
    margin: 0 ${({ theme }) => theme.spacing01};

    :disabled {
      cursor: auto;

      :hover {
        background: none;
      }
    }
  }
  .pagination-button {
    height: ${({ theme }) => theme.spacing05};
    width: ${({ theme }) => theme.spacing05};
    border: 1px solid ${({ theme }) => theme.colorUI30};
    transition: 0.05s linear background;
    :hover {
      background: ${({ theme }) => theme.colorUI20};
      transition: 0.05s linear background;
    }
    cursor: pointer;
    background: none;
    border-radius: ${({ theme }) => theme.borderRadius};

    > svg {
      font-size: ${({ theme }) => theme.fontSize03};
    }
  }
`;

const PaginationPageNumber = styled.li`
  border-radius: ${({ theme }) => theme.borderRadius};
  list-style: none;
  height: ${({ theme }) => theme.spacing05};
  width: ${({ theme }) => theme.spacing05};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  color: ${(props) => (props.isSelected ? 'white' : props.theme.colorText50)};
  background: ${(props) => (props.isSelected ? props.theme.colorPrimary50 : 'white')};
  border: 1px solid ${({ theme }) => theme.colorUI30};
  cursor: pointer;
  transition: 0.05s linear background;
  :hover {
    background: ${(props) => (props.isSelected ? props.theme.colorPrimary50 : props.theme.colorUI20)};
    transition: 0.05s linear background;
  }
`;

export default function Pagination({ resultsPerPage = 10, numberOfResults, onChangePageClick, currentPage }) {
  function displayPages() {
    const numberOfPages = Math.ceil(numberOfResults / resultsPerPage);
    if (numberOfPages > 5) {
      let order = [];
      if (currentPage === 1) {
        order.push(currentPage, currentPage + 1, currentPage + 2, numberOfPages);
        return order;
      }

      if (currentPage === 2) {
        order.push(currentPage - 1, currentPage, currentPage + 1, currentPage + 2, numberOfPages);
        return order;
      }
      if (currentPage === numberOfPages - 1) {
        order.push(1, currentPage - 2, currentPage - 1, currentPage, currentPage + 1);
        return order;
      }

      if (currentPage === numberOfPages - 2) {
        order.push(1, currentPage - 1, currentPage, currentPage + 1, numberOfPages);
        return order;
      }

      if (currentPage === numberOfPages) {
        order.push(1, currentPage - 3, currentPage - 2, currentPage - 1, currentPage);
        return order;
      }

      order.push(1, currentPage - 1, currentPage, currentPage + 1, numberOfPages);
      return order;
    } else {
      const pages = Array.from(Array(numberOfPages).keys()).map((item) => item + 1);
      return pages;
    }
  }

  function onNextPageClick() {
    const page = currentPage + 1;
    onChangePageClick(page);
  }

  function onPreviousPageClick() {
    const page = currentPage - 1;
    onChangePageClick(page);
  }

  function onPageClick(page) {
    onChangePageClick(page);
  }

  return (
    <PaginationWrap>
      <button
        onClick={onPreviousPageClick}
        disabled={currentPage <= 1}
        className="pagination-button page-item"
      >
        <BsChevronLeft />
      </button>
      {displayPages().map((page, index) => {
        return (
          <PaginationPageNumber
            key={page}
            onClick={() => onPageClick(parseInt(page))}
            isSelected={page === currentPage}
            tabIndex={index}
            className="page-item"
          >
            {page}
          </PaginationPageNumber>
        );
      })}
      <button
        onClick={onNextPageClick}
        disabled={currentPage >= Math.ceil(numberOfResults / resultsPerPage)}
        className="pagination-button page-item"
      >
        <BsChevronRight />
      </button>
    </PaginationWrap>
  );
}
